module.exports = __webpack_public_path__ + "static/media/wilton.63dc4b33.png";